import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPages.css';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simular envío de formulario
    setTimeout(() => {
      setSubmitted(true);
      setLoading(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      
      // Limpiar mensaje después de 3 segundos
      setTimeout(() => setSubmitted(false), 3000);
    }, 1000);
  };

  return (
    <div className="legal-page">
      <Navbar cartItemCount={0} />
      
      <div className="legal-content">
        <div className="legal-container">
          <h1>Contacto</h1>
          <p className="intro-text">¿Tienes preguntas? Estamos aquí para ayudarte. Contáctanos a través de cualquiera de estos métodos.</p>

          <div className="contact-wrapper">
            {/* FORMULARIO DE CONTACTO */}
            <div className="contact-form-section">
              <h2>Envíanos un Mensaje</h2>
              
              {submitted && (
                <div className="success-message">
                  ✓ ¡Gracias por tu mensaje! Nos pondremos en contacto pronto.
                </div>
              )}

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nombre Completo *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Correo Electrónico *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="tu@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Teléfono</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+54 (código) XXXXXXX"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Asunto *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="¿Sobre qué es tu consulta?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mensaje *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Cuéntanos cómo podemos ayudarte..."
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? 'Enviando...' : 'Enviar Mensaje'}
                </button>
              </form>
            </div>

            {/* INFORMACIÓN DE CONTACTO */}
            <div className="contact-info-section">
              <h2>Información de Contacto</h2>

              <div className="contact-box">
                <h3>📧 Correo Electrónico</h3>
                <p><a href="mailto:info@solylunakiosko.com">info@solylunakiosko.com</a></p>
                <p className="contact-note">Respuesta en 24-48 horas</p>
              </div>

              <div className="contact-box">
                <h3>📞 Teléfono</h3>
                <p>+54 (código) XXXXXXX</p>
                <p className="contact-note">Lunes a Viernes: 9:00 - 18:00</p>
              </div>

              <div className="contact-box">
                <h3>💬 WhatsApp</h3>
                <p><a href="https://wa.me/tu_numero" target="_blank" rel="noopener noreferrer">
                  Enviar mensaje por WhatsApp
                </a></p>
                <p className="contact-note">Respuesta inmediata disponible</p>
              </div>

              <div className="contact-box">
                <h3>📍 Nuestras Tiendas</h3>
                <ul className="store-list">
                  <li>
                    <strong>Centro:</strong><br/>
                    Chacabuco y Lavalle<br/>
                    Lun-Vie: 8:00 - 20:00 | Sáb: 9:00 - 19:00 | Dom: 10:00 - 18:00
                  </li>
                  <li>
                    <strong>Norte:</strong><br/>
                    9 de Julio y Saavedra<br/>
                    Lun-Vie: 8:00 - 20:00 | Sáb: 9:00 - 19:00 | Dom: 10:00 - 18:00
                  </li>
                  <li>
                    <strong>Sur:</strong><br/>
                    Almafuerte y Quintana<br/>
                    Lun-Vie: 8:00 - 20:00 | Sáb: 9:00 - 19:00 | Dom: 10:00 - 18:00
                  </li>
                </ul>
              </div>

              <div className="contact-box">
                <h3>🕐 Horarios de Atención</h3>
                <ul className="schedule">
                  <li><strong>Lunes a Viernes:</strong> 8:00 AM - 8:00 PM</li>
                  <li><strong>Sábado:</strong> 9:00 AM - 7:00 PM</li>
                  <li><strong>Domingo:</strong> 10:00 AM - 6:00 PM</li>
                </ul>
              </div>

              <div className="contact-box social">
                <h3>🌐 Síguenos en Redes</h3>
                <div className="social-links-contact">
                  <a href="https://www.instagram.com/solyluna_kiosko/" target="_blank" rel="noopener noreferrer">
                    Instagram
                  </a>
                  <a href="https://www.facebook.com/profile.php?id=100075540712787" target="_blank" rel="noopener noreferrer">
                    Facebook
                  </a>
                  <a href="https://wa.me/tu_numero" target="_blank" rel="noopener noreferrer">
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* SECCIÓN DE PREGUNTAS FRECUENTES */}
          <section className="legal-section" style={{ marginTop: '40px' }}>
            <h2>Preguntas Frecuentes</h2>
            
            <div className="faq-item">
              <h3>¿Cuáles son los tiempos de entrega?</h3>
              <p>
                Ofrecemos entrega dentro de Argentina. El tiempo de entrega varía según la ubicación:
                <ul>
                  <li>Zona Centro: 1-2 días hábiles</li>
                  <li>Interior del país: 3-5 días hábiles</li>
                  <li>Localidades remotas: Consultar tiempos</li>
                </ul>
              </p>
            </div>

            <div className="faq-item">
              <h3>¿Cómo realizo un cambio o devolución?</h3>
              <p>
                Puedes devolver productos dentro de 15 días de la compra. Los artículos deben estar en perfecto estado y sin usar.
                Contactanos para coordinar la devolución.
              </p>
            </div>

            <div className="faq-item">
              <h3>¿Cuáles son los métodos de pago disponibles?</h3>
              <p>
                Aceptamos:
                <ul>
                  <li>Tarjetas de crédito (Visa, Mastercard)</li>
                  <li>Tarjetas de débito</li>
                  <li>Mercado Pago</li>
                  <li>Efectivo en nuestras tiendas</li>
                </ul>
              </p>
            </div>

            <div className="faq-item">
              <h3>¿Es seguro comprar en línea?</h3>
              <p>
                Sí, utilizamos encriptación SSL/TLS de grado comercial para proteger tus datos personales y de pago.
                Todos nuestros sistemas cumplen con estándares internacionales de seguridad.
              </p>
            </div>

            <div className="faq-item">
              <h3>¿Qué pasa si tengo un problema con mi pedido?</h3>
              <p>
                Si tienes cualquier problema con tu pedido, contáctanos inmediatamente. Nuestro equipo de atención al cliente
                está disponible para resolver cualquier inconveniente de manera rápida y eficiente.
              </p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
